import { useCreate, useDelete, useGetAll, useGetOne, useUpdate } from "./crudService";

const endpoint:string = 'trainings';

export function useGetAllTrainings(params:{page:number}, queryParams:any = {}) {
    return useGetAll({queryKey: [endpoint], ...queryParams}, params);
}

export function useGetTraining(id: number, params:any = {}) {
    return useGetOne({queryKey: [endpoint, id], ...params});
}

export function useCreateTraining() {
    return useCreate({queryKey: [endpoint]});
}

export function useUpdateTraining({id}) {
    return useUpdate({queryKey: [endpoint, id]});
}

export function useDeleteTraining({id}) {
    return useDelete({queryKey: [endpoint, id]});
}
